import React from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import AttachmentsLightBox from './AttachmentsLightBox';
import { Button } from '@progress/kendo-react-buttons';
import { useCurrentUserContext } from '../../../../context/UserContext';

const AttachmentsPopup: React.FC = () => {
    const navigate = useNavigate();
    const { profile: userProfile } = useCurrentUserContext();
    const [fileCount, setFileCount] = React.useState(0);

    return (
        <Window resizable={false} modal={true} className='cool-window fixed-window' initialHeight={700} initialWidth={Math.min(800, window.innerWidth - 10)} maximizeButton={() => null}
            minimizeButton={() => null} title={<><SvgIcon size='large' icon={svg.paperclipIcon} className='mr-2' ></SvgIcon>{fileCount} Attachment{fileCount === 1 ? '' : 's'}</>} onClose={() => navigate(-1)}>
            <AttachmentsLightBox gotAttachments={(files) => setFileCount(files?.length)} showSearch={true} showInfo={true} showPaging={true} />
            <WindowActionsBar >
                <Button style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }} size='large' onClick={(e) => navigate(-1)}>Close</Button>
            </WindowActionsBar>
        </Window>
    );
};

export default AttachmentsPopup;